import { getPathname } from './url';

// campaign type constants (backend is expecting uppercase)
export const CAMPAIGN_TYPE = {
  season: 'SEASON',
  edit: 'EDIT',
  shop: 'SHOP',
};

export const CAMPAIGN_WINDOWS = {
  zero: '0 Window',
  one: '1 Window',
  two: '2 Windows',
};

export const CAMPAIGN_STATUS = {
  beforeStart: 'before_start',
  windowOne: 'window_one',
  mid: 'mid',
  windowTwo: 'window_two',
  ended: 'ended',
};

export const getCampaignType = () => {
  const pathname = getPathname();
  if (pathname.includes('edit')) {
    return CAMPAIGN_TYPE.edit;
  }
  if (pathname.includes('add-ons')) {
    return CAMPAIGN_TYPE.season;
  }
  if (pathname.includes('shop')) {
    return CAMPAIGN_TYPE.shop;
  }
  return '';
};

export const CAMPAIGN_TYPES = [
  { value: 'NEW_MEMBER', name: 'New Member' },
  { value: 'EDIT', name: 'Edit' },
  { value: 'SEASON', name: 'Season' },
  { value: 'BOOST', name: 'Boost' },
  { value: 'SHOP', name: 'Shop' },
];

export const CAMPAIGN_WINDOWS_LIST = [
  { value: CAMPAIGN_WINDOWS.one, name: '1 Window' },
  { value: CAMPAIGN_WINDOWS.two, name: '2 Windows' },
];

export const VERSION = {
  'add-ons': 'add-ons',
  edit: 'edit',
  shop: 'shop',
};

export const campaignId = new URL(window.location.href).searchParams.get(
  'campaign_id'
);

export const campaignStatus = new URL(window.location.href).searchParams.get(
  'campaign_status'
);
